export const profileContainer = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100vw",
};
